import React, { Component } from 'react';
import SideMenu from '../admin/SideMenu';
import TopMenu from '../admin/TopBar';
import { base } from '../../base';
import '../../styles/css/AdminMain.css';
import RichTextMarkdown from "../utils/RichTextMarkdown";
import { isEmptyHtmlEntity, validateEmail } from "../utils/HelpfulFunction";
import { showErrorPopup, showInfoPopup, showToast } from '../utils/SwalConfig';
import FormCheckboxField from './FormCheckboxField';
const google = window.google;
let geocoder = new google.maps.Geocoder();
const isValidDomain = require('is-valid-domain');

class SetUpLoginVariables extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            tenantVariables: {},
            advanced: false
        };
        this.handleChange = this.handleChange.bind(this);
        this.handleTextChange = this.handleTextChange.bind(this);
    }

    componentDidMount() {
        this.tenantVariablesRef = base.syncState(`tenantVariables`, {
            context: this,
            state: 'tenantVariables',
            then() {
                const tenantVariables = this.state.tenantVariables;
                let advanced = false;
                if (tenantVariables.doNotCollectEmail || tenantVariables.sanitizeEmails || tenantVariables.allowList || tenantVariables.blockList || tenantVariables.collectDistance || tenantVariables.noMandatoryTermsAndConditions) {
                    advanced = true;
                }
                if (tenantVariables) {
                    this.setState({
                        acceptableDistance: tenantVariables.acceptableDistance,
                        locationPermissionsBody: tenantVariables.locationPermissionsBody,
                        locationPermissionsHeader: tenantVariables.locationPermissionsHeader,
                        formattedAddress: tenantVariables.formattedAddress,
                        notAcceptableLocationMessage: tenantVariables.notAcceptableLocationMessage,
                        notAcceptableLocationHeader: tenantVariables.notAcceptableLocationHeader,
                        canPlayOutside: tenantVariables.canPlayOutside,
                        allowList: tenantVariables.allowList,
                        blockList: tenantVariables.blockList,
                        advanced: advanced,
                        loading: false
                    });
                }
            }
        });
    }

    componentWillUnmount() {
        base.removeBinding(this.tenantVariablesRef);
    }

    handleChange(evt) {
        const target = evt.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        this.setState({ [evt.target.name]: value });
    }

    handleTextChange(evt) {
        const tenantVariablesCopy = this.state.tenantVariables;
        tenantVariablesCopy[evt.target.name] = evt.target.value;
        this.setState({ tenantVariables: tenantVariablesCopy });
    }

    handleRichTextChange = (name, text) => {
        const tenantVariablesCopy = this.state.tenantVariables;
        if (isEmptyHtmlEntity(text)) {
            text = "";
        }
        tenantVariablesCopy[name] = text;
        this.setState({ tenantVariables: tenantVariablesCopy });
    }

    selectOption(button) {
        const tenantVariablesCopy = this.state.tenantVariables || {};
        tenantVariablesCopy[button] = !tenantVariablesCopy[button];
        this.setState({ tenantVariables: tenantVariablesCopy });
    }

    updateDistance() {
        const tenantVariables = this.state.tenantVariables || {};
        if (!this.state.acceptableDistance || !this.state.formattedAddress) {
            showInfoPopup('Hold on!', 'Please make sure all the form fields are filled out');
            return;
        }
        if (this.state.acceptableDistance <= 0) {
            showInfoPopup('Hold on!', 'Please make sure distance is greater than 0');
            return;
        }
        const canPlayOutside = this.state.canPlayOutside || false;
        this.setState({ loading: true });
        const vm = this;
        let notAcceptableLocationMessage = vm.state.notAcceptableLocationMessage;
        if (isEmptyHtmlEntity(notAcceptableLocationMessage)) {
            notAcceptableLocationMessage = "";
        }
        geocoder.geocode({ 'address': this.state.formattedAddress }, function (results, status) {
            if (status === 'OK') {
                if (results.length === 1) {
                    const tenantVariablesCopy = tenantVariables;
                    tenantVariablesCopy["formattedAddress"] = vm.state.formattedAddress;
                    tenantVariablesCopy["acceptableDistance"] = vm.state.acceptableDistance;
                    tenantVariablesCopy["longitude"] = results[0].geometry.location.lng();
                    tenantVariablesCopy["latitude"] = results[0].geometry.location.lat();
                    tenantVariablesCopy["locationPermissionsBody"] = vm.state.locationPermissionsBody || "";
                    tenantVariablesCopy["locationPermissionsHeader"] = vm.state.locationPermissionsHeader || "";
                    tenantVariablesCopy["notAcceptableLocationMessage"] = notAcceptableLocationMessage;
                    tenantVariablesCopy["notAcceptableLocationHeader"] = vm.state.notAcceptableLocationHeader || "";
                    tenantVariablesCopy["canPlayOutside"] = canPlayOutside;
                    vm.setState({
                        tenantVariables: tenantVariablesCopy,
                        loading: false
                    });
                    showToast('Updates Successful');
                } else {
                    vm.setState({ loading: false });
                    showInfoPopup('Hold on!', "Too many locations have that address! Add more detail to get only 1 address");
                }
            } else {
                vm.setState({ loading: false });
                showInfoPopup('Hold on!', 'Finding address was not successful because ' + status);
            }
        });
    }

    updateList(listToUpdate) {
        const listName = listToUpdate + 'List';
        let listToSave = this.state[listName] || "";
        listToSave = listToSave.trim().toLowerCase();
        let rejoinedCleanedDomainsEmails = "";
        if (listToSave) {
            const splitList = listToSave.split(/[ ,\s]+/);
            for (const splitListIndex in splitList) {
                const splitItem = splitList[splitListIndex];
                let valid;
                if (splitItem.indexOf('@') === -1) {
                    valid = isValidDomain(splitItem);
                } else {
                    valid = validateEmail(splitItem);
                }
                if (!valid) {
                    showInfoPopup('Hold on!', "One of the items on the block list isn't a valid email or domain. The item causing an issue is: " + splitItem + ".");
                    return;
                }
            }
            rejoinedCleanedDomainsEmails = splitList.join(" ");
        }
        base.update(`tenantVariables`, {
            data: { [listName]: rejoinedCleanedDomainsEmails },
            then(err) {
                if (err) {
                    showErrorPopup('There was some error!', 'Try again and if the problem persists try logging out and logging back in');
                } else {
                    showToast('List Updated');
                }
            }
        });
    }

    renderBasicFieldsSection() {
        const variables = this.state.tenantVariables || {};
        const collectName = variables.collectName;
        const nameInEmail = variables.nameInEmail;
        const collectZipCode = variables.collectZipCode;
        const collectBirthday = variables.collectBirthday;
        const formBirthday = variables.formBirthday;

        return (
            <>
                <FormCheckboxField
                    id="collectName"
                    label="Collect Name Of Fan"
                    helpText="Check this box to add a MANDATORY name field to the login flow"
                    checked={collectName}
                    onChange={() => this.selectOption("collectName")}
                >
                    <div className="form-group">
                        <label htmlFor="nameInEmail">Include Name In Email</label>
                        <br />
                        <input type="checkbox" checked={nameInEmail} id="nameInEmail" name="nameInEmail" onClick={() => this.selectOption("nameInEmail")} />
                    </div>
                </FormCheckboxField>

                <FormCheckboxField
                    id="collectZipCode"
                    label="Collect ZipCode"
                    helpText="Check this box to add a MANDATORY zip code field to the login flow"
                    checked={collectZipCode}
                    onChange={() => this.selectOption("collectZipCode")}
                />

                <FormCheckboxField
                    id="collectBirthday"
                    label="Collect Birthday"
                    helpText="Check this box to add a MANDATORY birthday input field"
                    checked={collectBirthday}
                    onChange={() => this.selectOption("collectBirthday")}
                >
                    <div className="form-group">
                        <label htmlFor="allowedAge">Age</label>
                        <p className="form-help-text">Enter an age that the user must be above to play</p>
                        <input type="number" id="allowedAge" name="allowedAge" className="form-control" value={variables.allowedAge} onChange={this.handleTextChange} />
                    </div>
                    <div className="form-group">
                        <label className="radio-inline" style={{ marginRight: 5 }}><input type="radio" name="formBirthday" id="formBirthday" onChange={() => this.selectOption("formBirthday")} checked={formBirthday} /> In Form Birthday Input</label>
                        <label className="radio-inline"><input type="radio" name="formBirthday" id="formBirthday" onChange={() => this.selectOption("formBirthday")} checked={!formBirthday} /> Page Birthday Input</label>
                    </div>
                </FormCheckboxField>
            </>
        );
    }

    renderOptInSection() {
        const variables = this.state.tenantVariables || {};
        const collectOptIn = variables.collectOptIn;

        return (
            <FormCheckboxField
                id="collectOptIn"
                label="Turn on Optional Opt-In"
                helpText="Check this box to add a optional field to the login flow, enter the text below"
                checked={collectOptIn}
                onChange={() => this.selectOption("collectOptIn")}
            >
                <div className="form-group">
                    <label htmlFor="promotionText">Opt-In Text</label>
                    <p className="form-help-text">Text That Shows Next To Opt-In Check Box</p>
                    <textarea id="promotionText" name="promotionText" className="form-control" value={variables.promotionText} onChange={this.handleTextChange} />
                </div>
            </FormCheckboxField>
        );
    }

    renderUsernameSection() {
        const variables = this.state.tenantVariables || {};
        const collectUsername = variables.collectUsername;

        return (
            <FormCheckboxField
                id="collectUsername"
                label="Collect Username"
                helpText="Check this box to give each fan an auto-generated username after login. Fans no longer type their own name, so nothing vulgar can get through. The username is shown on the leaderboard in place of the fan's name."
                checked={collectUsername}
                onChange={() => this.selectOption("collectUsername")}
            >
                <div className="form-group">
                    <label htmlFor="usernameCollectionHeader">Username Screen Header</label>
                    <p className="form-help-text">Heading shown above the fan's assigned username</p>
                    <input value={variables.usernameCollectionHeader} className="form-control" type="text" id="usernameCollectionHeader" name="usernameCollectionHeader" placeholder="Your Username" onChange={this.handleTextChange} />
                </div>
                <div className="form-group">
                    <label htmlFor="usernameBaseWord">Username Base Word</label>
                    <p className="form-help-text">Optional. Enter a word to base usernames on &mdash; e.g. <strong>all-star</strong> produces all-star8391, all-star204. Leave blank to generate fun random names like BraveFalcon7, SwiftTiger42. Maximum 9 characters, so the number on the end still fits on the leaderboard.</p>
                    <input value={variables.usernameBaseWord} className="form-control" type="text" id="usernameBaseWord" name="usernameBaseWord" maxLength="9" placeholder="Leave blank for random names" onChange={this.handleTextChange} />
                </div>
                <div className="form-group">
                    <label htmlFor="usernameButtonText">Play Button Text</label>
                    <p className="form-help-text">Text on the button that starts the game</p>
                    <input value={variables.usernameButtonText} className="form-control" type="text" id="usernameButtonText" name="usernameButtonText" placeholder="Let's Play!" onChange={this.handleTextChange} />
                </div>
            </FormCheckboxField>
        );
    }

    renderAdvancedToggle() {
        return (
            <div className="form-checkbox-field">
                <div className="form-group">
                    <label htmlFor="showAdvancedSettings">Advanced</label>
                    <p className="form-help-text">Show advanced settings for email, geolocation, and access lists</p>
                    <input type="checkbox" checked={this.state.advanced} id="advanced" name="advanced" onChange={this.handleChange} />
                </div>
            </div>
        );
    }

    renderAdvancedSection() {
        if (!this.state.advanced) {
            return null;
        }

        const variables = this.state.tenantVariables || {};
        const doNotCollectEmail = variables.doNotCollectEmail;
        const noMandatoryTermsAndConditions = variables.noMandatoryTermsAndConditions;
        const sanitizeEmails = variables.sanitizeEmails;
        const collectDistance = variables.collectDistance;
        const collectZipCode = variables.collectZipCode;
        const doNotVerifyAmericanZipCode = variables.doNotVerifyAmericanZipCode;
        const canPlayOutside = this.state.canPlayOutside;
        const acceptableDistance = parseFloat(this.state.acceptableDistance);
        const formattedAddress = this.state.formattedAddress;
        const locationPermissionsBody = this.state.locationPermissionsBody;
        const locationPermissionsHeader = this.state.locationPermissionsHeader;
        const notAcceptableLocationMessage = this.state.notAcceptableLocationMessage;
        const notAcceptableLocationHeader = this.state.notAcceptableLocationHeader;

        return (
            <>
                <FormCheckboxField
                    id="collectDistance"
                    label="Turn On/Off Geolocation"
                    helpText="Check this box to add MANDATORY verification of distance from stadium"
                    checked={collectDistance}
                    onChange={() => this.selectOption("collectDistance")}
                >
                    <div className="form-group">
                        <label htmlFor="formattedAddress" className="form-label-spaced">Address</label>
                        <br />
                        <input className="form-control" type="text" id="formattedAddress" name="formattedAddress" value={formattedAddress} onChange={this.handleChange} placeholder="Address" />
                    </div>
                    <div className="form-group">
                        <label htmlFor="locationPermissionsHeader" className="form-label-spaced">Requesting Location Permissions Header</label>
                        <br />
                        <input className="form-control" type="text" id="locationPermissionsHeader" name="locationPermissionsHeader" value={locationPermissionsHeader} onChange={this.handleChange} placeholder="Location Permissions Header" />
                    </div>
                    <div className="form-group">
                        <label htmlFor="locationPermissionsBody" className="form-label-spaced">Requesting Location Permissions Body</label>
                        <br />
                        <textarea className="form-control" id="locationPermissionsBody" name="locationPermissionsBody" value={locationPermissionsBody} onChange={this.handleChange} placeholder="Location Permissions Body" />
                    </div>
                    <div className="form-group">
                        <label htmlFor="notAcceptableLocationHeader" className="form-label-spaced">Not Acceptable Location Header</label>
                        <br />
                        <input className="form-control" type="text" id="notAcceptableLocationHeader" name="notAcceptableLocationHeader" value={notAcceptableLocationHeader} onChange={this.handleChange} placeholder="Not Acceptable Location Header" />
                    </div>
                    <div className="form-group">
                        <label htmlFor="notAcceptableLocationMessage" className="form-label-spaced">Not Acceptable Location Message</label>
                        <br />
                        <RichTextMarkdown
                            field={{
                                id: "notAcceptableLocationMessage",
                                name: "notAcceptableLocationMessage",
                                value: notAcceptableLocationMessage,
                            }}
                            form={{
                                setFieldValue: (field, value) => this.setState({ notAcceptableLocationMessage: value })
                            }}
                            placeholder="Not Acceptable Location Message"
                        />
                    </div>
                    <div className="form-group">
                        <label htmlFor="acceptableDistance" className="form-label-spaced">Distance (Miles)</label>
                        <div>
                            <input type="checkbox" onClick={() => this.setState({ canPlayOutside: false })} checked={!canPlayOutside} /> Fans Can Play Within
                            <input onClick={() => this.setState({ canPlayOutside: true })} type="checkbox" checked={canPlayOutside} style={{ marginLeft: 10 }} /> Fans Can Play Outside
                        </div>
                        <input className="form-control" type="number" id="acceptableDistance" step="0.1" name="acceptableDistance" min="0" value={acceptableDistance} onChange={this.handleChange} placeholder="" />
                        <button className="btn btn-primary btn-lg update-button btn-margin-top" onClick={() => this.updateDistance()}><span className="fa fa-arrow-circle-o-up" /> Update Distance Variables</button>
                    </div>
                </FormCheckboxField>

                <FormCheckboxField
                    id="doNotCollectEmail"
                    label="DO NOT Collect Email"
                    helpText="Check this box to remove all email collection from the game"
                    checked={doNotCollectEmail}
                    onChange={() => this.selectOption("doNotCollectEmail")}
                />

                <FormCheckboxField
                    id="noMandatoryTermsAndConditions"
                    label="Turn OFF Mandatory Terms And Conditions"
                    helpText={<span>Check this box to remove the MANDATORY confirm rules and regs checkbox<br />Rules and Regs Text and Link come from the <a href="/setuprulesandregs"><u>Rules and Regs Tab</u></a></span>}
                    checked={noMandatoryTermsAndConditions}
                    onChange={() => this.selectOption("noMandatoryTermsAndConditions")}
                />

                <FormCheckboxField
                    id="sanitizeEmails"
                    label="Sanitize Emails"
                    helpText={<span>Check this box to map accounts with the same sanitized email to the same account<br />(could lead to issues with users having the same email address)</span>}
                    checked={sanitizeEmails}
                    onChange={() => this.selectOption("sanitizeEmails")}
                />

                {collectZipCode &&
                    <FormCheckboxField
                        id="doNotVerifyAmericanZipCode"
                        label="Do Not Verify American Zip Code?"
                        helpText="Do not verify American Zip Code. Check this only if the zip codes you are collecting are outside the U.S."
                        checked={doNotVerifyAmericanZipCode}
                        onChange={() => this.selectOption("doNotVerifyAmericanZipCode")}
                    />
                }

                <div className="form-checkbox-field">
                    <div className="form-group">
                        <label htmlFor="blockList">Block List Emails/Domains</label>
                        <p className="form-help-text">Enter any emails or domains that should be blocked from logging in.</p>
                        <textarea className="form-control" id="blockList" name="blockList" value={this.state.blockList} onChange={this.handleChange} />
                        <button className="btn btn-primary btn-lg update-button btn-margin-top" onClick={() => this.updateList('block')}><span className="fa fa-arrow-circle-o-up" /> Update Block List</button>
                    </div>
                </div>

                <div className="form-checkbox-field">
                    <div className="form-group">
                        <label htmlFor="allowList">Allow List Emails/Domains</label>
                        <p className="form-help-text">Enter any emails or domains that should be allowed to login, all other emails/domains will be blocked. This will SUPERSEDE any emails/domains on the block list and let them play</p>
                        <textarea className="form-control" id="allowList" name="allowList" value={this.state.allowList} onChange={this.handleChange} />
                        <button className="btn btn-primary btn-lg update-button btn-margin-top" onClick={() => this.updateList('allow')}><span className="fa fa-arrow-circle-o-up" /> Update Allow List</button>
                    </div>
                </div>
            </>
        );
    }

    renderMlbSection() {
        const variables = this.state.tenantVariables || {};
        const noMandatoryTermsAndConditions = variables.noMandatoryTermsAndConditions;

        return (
            <>
                <FormCheckboxField
                    id="noMandatoryTermsAndConditions"
                    label="Turn OFF Mandatory Terms And Conditions"
                    helpText={<span>Check this box to remove the MANDATORY confirm rules and regs checkbox<br />Rules and Regs Text and Link come from the <a href="/setuprulesandregs"><u>Rules and Regs Tab</u></a></span>}
                    checked={noMandatoryTermsAndConditions}
                    onChange={() => this.selectOption("noMandatoryTermsAndConditions")}
                />
                {this.renderUsernameSection()}
            </>
        );
    }

    renderInfoPanel() {
        return (
            <div className="container-out mobile-hide" style={{ width: '45%', float: 'right', marginRight: '20px' }}>
                <div className="admin-form-box" style={{ border: '1px solid black', backgroundColor: 'white' }}>
                    <p className="info-panel-title">What Data Should I Gather?</p>
                    <p className="text-muted2">Think carefully about what you want to gather from your fan base. The more you ask for, the fewer people will be willing to go through the whole logging in process.
                        Balance that with useful parameters that you can use to help your fans get more value from your experience.</p>
                </div>
            </div>
        );
    }

    render() {
        const isMlbTeam = process.env.REACT_APP_IS_MLB_TEAM === "true";

        return (
            <div className="admin-wrapper">
                <div className="loading-screen" style={{ display: this.state.loading ? 'block' : 'none' }} />
                <SideMenu />
                <TopMenu />
                <div className="admin-main-panel">
                    {!isMlbTeam ? (
                        <>
                            <div className="container-out container-left-rules" style={{ float: "left", width: "50%" }}>
                                <div className="admin-form-box">
                                    {this.renderBasicFieldsSection()}
                                    {this.renderOptInSection()}
                                    {this.renderUsernameSection()}
                                    {this.renderAdvancedToggle()}
                                    {this.renderAdvancedSection()}
                                </div>
                            </div>
                            {this.renderInfoPanel()}
                        </>
                    ) : (
                        <div className="container-out container-left-rules">
                            <div className="admin-form-box">
                                {this.renderMlbSection()}
                            </div>
                        </div>
                    )}
                </div>
            </div>
        );
    }
}

export default SetUpLoginVariables;
